<template>

  <body id="app" :class="bodyClass">
    <!-- 网站黑框 -->
    <div id="site-border-left"></div>
    <div id="site-border-right"></div>
    <div id="site-border-top"></div>
    <div id="site-border-bottom"></div>
    <!-- 网站顶部导航 -->
    <header>
      <nav class="navbar navbar-fixed-top" :class="navbarClass">
        <div class="container">
          <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#navbar-collapse" aria-expanded="false">
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
          <div class="collapse navbar-collapse" id="navbar-collapse">
            <ul class="nav navbar-nav ">
              <li>
                <router-link :to="{name: 'Index'}" tag="a">
                  01 : 首页
                </router-link>
              </li>
              <li>
                <router-link :to="{name: 'Works'}" tag="a">
                  02 : 案例
                </router-link>
              </li>
              <li>
                <router-link :to="{name: 'Self'}" tag="a">
                  03 : 自营
                </router-link>
              </li>
              <li>
                <router-link :to="{name: 'AboutUs'}" tag="a">
                  04 : 关于我们
                </router-link>
              </li>
              <li>
                <router-link :to="{name: 'Contact'}" tag="a">
                  05 : 联系我们
                </router-link>
              </li>
              <li>
                <router-link :to="{name: 'Announce'}" tag="a">
                  06 : 招标公示
                </router-link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
    <!-- 网站顶部导航 -->
    <!-- router-view 路由容器 -->
    <router-view />
    <!-- router-view 路由容器 -->
    <!-- 网站页脚 -->
    <footer class="footer-container text-center" v-if="isFooterShow">
      <div class="container">
        <div class="row">
          <div class="col-xs-12">
            <p>Copyright © 2013-2020 诺朗科技
              <a href="https://beian.miit.gov.cn" id="beian" target="_blank">蜀ICP备13019233号-3</a>
              <!-- <a href="https://beian.miit.gov.cn" id="beian" target="_blank">蜀ICP备13019233号-2</a> -->
            </p>
          </div>
        </div>
      </div>
    </footer>
    <!-- 网站页脚 -->
  </body>
</template>
<script>
export default {
  computed: {
    routeName() {
      return this.$route.name
    },
    // body的class类名
    bodyClass() {
      if (this.routeName === 'Index') {
        return 'minimal'
      } else {
        return null
      }
    },
    // 顶部的导航栏的样式
    navbarClass() {
      if (this.routeName === 'Index') {
        return 'navbar-inverse'
      } else {
        return 'navbar-default'
      }
    },
    // 是否展示网站页脚
    isFooterShow() {
      if (this.routeName === 'Index') {
        return false
      } else {
        return true
      }
    },
  },
  mounted() {
    require('@/utils/main.js')
  },
}
</script>
<style lang="scss">
@import url('./assets/scss/main.css');
@import url('./assets/scss/modal-style.css');
.minimal {
  background: #000;
}
</style>